module.exports = __webpack_public_path__ + "school/img/activity_practice_course_tab_bg.6223c045.png";